import { useApi } from "@apac/hooks";
import type { AlertKey, FlightKey } from "@b2bportal/air-price-watch-api";
import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { useDeleteWatchMutation } from "../store";

type UnWatchTripResponse =
  | {
      data: unknown;
      error?: undefined;
    }
  | {
      data?: undefined;
      error: FetchBaseQueryError | SerializedError;
    };

export interface UseDeleteWatchTripParams {
  flightKey: AlertKey;
}

export interface UseDeleteTripWatchTripReturn {
  context: {
    isSubmitting: boolean;
  };
  handlers: {
    unwatch: () => Promise<UnWatchTripResponse>;
  };
}

export const useDeleteWatchTrip = ({
  flightKey,
}: UseDeleteWatchTripParams): UseDeleteTripWatchTripReturn => {
  const [deleteWatch, { isLoading }] = useDeleteWatchMutation();
  const unwatchApi = useApi((request: { flightKey: FlightKey }) =>
    deleteWatch({ key: request.flightKey })
  );

  return {
    context: { isSubmitting: isLoading },
    handlers: { unwatch: () => unwatchApi.trigger({ flightKey }) },
  };
};
